/**
 * @param {*} object
 * @param {string} key
 * @return {string|undefined}
 */
const getNestedValueByKey = (object, key) => {
    return key.split('.').reduce((acc, curr) => acc && acc[curr], object);
};

// TODO: make this somehow typesafe and typehint in IDEs?!
/**
 * Retrieves a translated key from a dictionary on the window object
 * Example: ${i18n('CustomElement.buttonLabel', 'Label')}
 * @param {string} key to be translated
 * @param {string} [fallback] to be used if key is not defined
 * @return {string} String of the translated key or fallback or original key
 */
export default function (key, fallback) {
    const translations = globalThis.app_config?.i18n || {};
    const value = getNestedValueByKey(translations, key);

    if (value) {
        return value;
    }

    console.warn('Translation Missing for key: ', key);
    return fallback || key;
}
